import { graphql } from '@eluve/graphql.tada';

import { templateBundleListItemFragment } from './template-bundle.operations';

export const templateBundleDefaultFragment = graphql(
  `
    fragment TemplateBundleDefault on TemplateBundleDefaults @_unmask {
      __typename
      id
      tenantId
      templateBundleId
      specialty
      language
      createdAt
      updatedAt
      template_bundle {
        ...TemplateBundleListItem
      }
      tenant {
        __typename
        id
        name
      }
    }
  `,
  [templateBundleListItemFragment],
);

export const getTenantTemplateBundleDefaultsQuery = graphql(
  `
    query getTenantTemplateBundleDefaults($tenantId: uuid!) {
      tenantDefaults: templateBundleDefaults(
        where: { tenantId: { _eq: $tenantId } }
        orderBy: [{ specialty: ASC }, { language: ASC }, { createdAt: ASC }]
      ) {
        ...TemplateBundleDefault
      }
    }
  `,
  [templateBundleDefaultFragment],
);

export const getTenantUsersForPersonalSettingsQuery = graphql(`
  query getTenantUsersForPersonalSettings($tenantId: uuid!) {
    tenantsByPk(id: $tenantId) {
      __typename
      id
      name
      tenantUsers(orderBy: { user: { firstName: ASC } }) {
        __typename
        tenantId
        userId
        user {
          __typename
          id
          firstName
          lastName
          email
        }
        settings {
          __typename
          tenantId
          userId
          defaultTemplateBundleId
        }
      }
    }
  }
`);

export const updateUserPersonalDefaultBundleMutation = graphql(`
  mutation updateUserPersonalDefaultBundle(
    $tenantId: uuid!
    $userId: uuid!
    $defaultTemplateBundleId: uuid
  ) {
    updateTenantUserSettingsByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { defaultTemplateBundleId: $defaultTemplateBundleId }
    ) {
      __typename
      tenantId
      userId
      defaultTemplateBundleId
    }
  }
`);

export const insertTemplateBundleDefaultMutation = graphql(
  `
    mutation insertTemplateBundleDefault(
      $tenantId: uuid!
      $templateBundleId: uuid!
      $specialty: citext
      $language: String
    ) {
      insertTemplateBundleDefaultsOne(
        object: {
          tenantId: $tenantId
          templateBundleId: $templateBundleId
          specialty: $specialty
          language: $language
        }
      ) {
        ...TemplateBundleDefault
      }
    }
  `,
  [templateBundleDefaultFragment],
);

export const updateTemplateBundleDefaultMutation = graphql(
  `
    mutation updateTemplateBundleDefault(
      $id: uuid!
      $tenantId: uuid!
      $templateBundleId: uuid!
      $specialty: citext
      $language: String
    ) {
      updateTemplateBundleDefaultsByPk(
        pkColumns: { id: $id }
        _set: {
          tenantId: $tenantId
          templateBundleId: $templateBundleId
          specialty: $specialty
          language: $language
        }
      ) {
        ...TemplateBundleDefault
      }
    }
  `,
  [templateBundleDefaultFragment],
);

export const deleteTemplateBundleDefaultMutation = graphql(`
  mutation deleteTemplateBundleDefault($id: uuid!) {
    deleteTemplateBundleDefaultsByPk(id: $id) {
      __typename
      id
    }
  }
`);
